import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private snackBar: MatSnackBar) { }

  showSuccess(text: string, duration?: number) {
    this.showNotification(text, duration, 'snackbar-success');
  }

  showWarning(text: string, duration?: number) {
    this.showNotification(text, duration, 'snackbar-warning');
  }

  showError(text: string, duration?: number) {
    this.showNotification(text, duration, 'snackbar-error');
  }

  setHorizontalPosition(position: MatSnackBarHorizontalPosition){
    this.horizontalPosition = position;
  }

  setVerticalPosition(position: MatSnackBarVerticalPosition){
    this.verticalPosition = position;
  }

  private showNotification(text: string, duration: number, panelClass: string) {
    this.snackBar.open(text, 'OK', duration ? {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: duration*1000,
      panelClass: [panelClass]
    } : {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: [panelClass]
    });
  }
}
